import { DataLayer } from '@/shared/services/gtm/models/models-gtm'

export class SearchResultsViewDataLayer extends DataLayer {
    public search_term: string

    public constructor(params: {
        searchTerm: string
        uniqueEventId?: number
        element?: string
        customerId?: string | null
    }) {
        super('view_search_results', params.uniqueEventId, params.element)

        this.search_term = params.searchTerm
        this.customerId = params.customerId
    }
}
